module.exports = import("/federated-search/client/remoteEntry.js");